import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { QAdapterService } from './q-adapter.service';

export const QAdapterModule = angular.module('q-adapter', []).name;

angular
  .module(QAdapterModule)
  .service('QAdapterService', downgradeInjectable(QAdapterService))
  .run([
    '$q',
    'QAdapterService',
    ($q: angular.IQService, $qAdapter: QAdapterService) => {
      // Push $q into the adapter
      $qAdapter.set$Q($q);
    },
  ]);
